import type {PreviewCtaComponentProps} from '@cohort/merchants/apps';
import ActionCtaPreview from '@cohort/merchants/apps/common/ActionCtaPreview';
import type {FacebookLikePageTriggerStruct} from '@cohort/shared/apps/facebook/triggers/likePage';
import React from 'react';
import {useTranslation} from 'react-i18next';

const FacebookLikePageTriggerActionCtaComponentPreview: React.FC<
  PreviewCtaComponentProps<FacebookLikePageTriggerStruct>
> = ({localizationConfig}) => {
  const {t} = useTranslation('app-facebook', {
    keyPrefix: 'triggers.like-page',
    lng: localizationConfig.desiredLanguage,
  });
  return <ActionCtaPreview text={t('ctaTitle')} />;
};

export default FacebookLikePageTriggerActionCtaComponentPreview;
